"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailVideo = AssetDetailVideo;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mux_video_react_1 = __importDefault(require("@mux/mux-video-react"));
const account_context_1 = require("@src/context/account-context");
const styled_components_1 = __importDefault(require("styled-components"));
const AssetDetailVideoContainer = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
`;
function AssetDetailVideo({ asset }) {
    const account = (0, account_context_1.useAccount)();
    return ((0, jsx_runtime_1.jsx)(AssetDetailVideoContainer, { children: (0, jsx_runtime_1.jsx)(mux_video_react_1.default, { style: { maxWidth: '100%' }, playbackId: asset.muxPublicPlaybackId, metadata: {
                video_id: String(asset.id),
                video_title: asset.filename,
                viewer_user_id: String(account === null || account === void 0 ? void 0 : account.id),
            }, 
            // @ts-ignore
            autoPlay: "muted", envKey: process.env.MUX_VIDEO_TRACK_KEY, 
            // @ts-ignore
            streamType: "on-demand", controls: true, disablePictureInPicture: true, height: "100%" }) }));
}
